import { render, staticRenderFns } from "./StudentsHeaderFilter.vue?vue&type=template&id=4a01e013&scoped=true"
import script from "./StudentsHeaderFilter.vue?vue&type=script&lang=js"
export * from "./StudentsHeaderFilter.vue?vue&type=script&lang=js"
import style0 from "./StudentsHeaderFilter.vue?vue&type=style&index=0&id=4a01e013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01e013",
  null
  
)

export default component.exports